import { render, staticRenderFns } from "./QuadientBulkMailer.vue?vue&type=template&id=b1030f28&scoped=true&"
import script from "./QuadientBulkMailer.vue?vue&type=script&lang=js&"
export * from "./QuadientBulkMailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1030f28",
  null
  
)

export default component.exports